<template>
	<div>
		<p class="text-center text-muted font-italic font-weight-bold mb-3">All names must be searched Last name, First name (Suffix). Ex. "Miller, Arthur" or "Hammerstein, Oscar II"</p>
		<b-row>
			<b-col xs="12">
				<b-form @submit.prevent="search">
					<b-input-group>
						<b-form-input v-model="query" :placeholder="placeholders[searchType]" type="text" />
						<b-form-select v-model="searchType" slot="append" :options="searchOptions">
						</b-form-select>
					</b-input-group>
				</b-form>
			</b-col>
		</b-row>
		<b-row class="mt-3" v-if="recs.length">
			<b-col xs="12">
				<b-card-group columns>
						<CardPerformance v-for="r in recs" :rec="r" />
				</b-card-group>
			</b-col>
		</b-row>
		<Credits v-else-if="clean" />
		<div v-else class="mt-3">
			<p>No Results</p>
		</div>
	</div>
</template>

<script>
import Vuex from 'vuex'

import CardPerformance from './data-items/CardPerformance.vue'
import Credits from './Credits.vue'

export default {
	name: 'Search',
	components: { CardPerformance, Credits },
	data: () => ({
		query: '',
		searchOptions: [
			{ text: 'All', value: 'SEARCH_ALL' },
			{ text: 'Author', value: 'SEARCH_AUTHOR' },
			{ text: 'Cast Members', value: 'SEARCH_CAST' },
			{ text: 'Title', value: 'SEARCH_TITLE'}
		],
		searchType: 'SEARCH_ALL',
		placeholders: {
			'SEARCH_ALL': 'Search for performances by title, year, date, cast member, or author',
			'SEARCH_AUTHOR': 'Search for performances by author',
			'SEARCH_CAST': 'Search for performances by cast member',
			'SEARCH_TITLE': 'Search for performances by title'
		}
	}),
	methods: {
		inspect(rec) {
			this.$store.dispatch('featured/inspect', {
				type: 'PERF',
				data: rec
			})
			this.$router.push({
				name: 'feature-performance',
				params: {
					id: rec.id,
				}
			})
		},
		search (quiet=false) {
			this.$router.push({
				name: 'search',
				query: {
					query: this.query,
					type: this.searchType
				}
			})
			this.$store.dispatch('search/searchPerformances', { query: this.query, searchType: this.searchType })
		}
	},
	computed: Vuex.mapState({
		recs: state => state.search.results,
		clean: state => state.search.clean
	}),
	created: function() {
		if(this.$route.query.query && this.$route.query.query.length) {
			this.query = this.$route.query.query
			this.searchType = this.$route.query.type
			this.search(true)
			console.log('wokeup and searched')
		}
	},
	watch: {
		clean: function(val) {
			if(val === true) {
				this.query = '';
			}
		},
		$route: function(to, from) {
			if(to.query.query && to.query.query.length) {
				this.query = to.query.query
				this.searchType = to.query.type
				this.search(true)
				console.log('changed and searched')
			} else {
				this.$store.dispatch('search/clear')
			}
		}
	}
}

</script>

<style>
.card-columns {
	column-gap: 3.25rem;
}
</style>
